import React from 'react';
// import PropTypes from 'prop-types';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import OrderTracking from './components/OrderTrackingPage';

const OrderTrackingPage = props => {
  const { search } = useLocation();
  const params = queryString.parse(search);
  const order_id = params.id || params.order_id;

  if (order_id) {
    return <OrderTracking orderId={order_id} {...props} />;
  }

  return (
    <div className="order-tracking-page" data-xc="order-tracking-page">
      <div className="text-lg font-bold tracker-msg">
        Unable to loading tracking details
      </div>
    </div>
  );
};

OrderTrackingPage.propTypes = {};

export default OrderTrackingPage;
